/* Judge.me preview badge (stars under the PDP title): clicking it should land
   the visitor on the Customer Reviews section with its title readable, not
   buried under the pinned two-row header. Judge.me's own click handler scrolls
   with a fixed offset that ignores our sticky header, so this capture-phase
   listener replaces it with a header-compensated scroll. (21 Aug 2026) */
document.addEventListener(
  'click',
  function (e) {
    const badge = e.target.closest('.jdgm-preview-badge');
    if (!badge) return;
    const target = document.querySelector('.jm-review-widget, .jdgm-review-widget');
    if (!target) return;
    e.preventDefault();
    e.stopPropagation();
    const header = document.getElementById('header-group');
    const offset = (header ? header.getBoundingClientRect().height : 0) + 16;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY - offset,
      behavior: reduce ? 'auto' : 'smooth',
    });
  },
  true
);
